import React from 'react'
import { Text } from 'react-native'

import Icon from 'react-native-vector-icons/dist/Feather';
import styled from 'styled-components/native';
const Container = styled.View`
    background-color: #f1f1f1;
    flex: 1;
    align-items: center;
    justify-content: center;
`;
const Card = styled.View`
    background-color: #ffffff;
    flex: 1;
    align-items: center;
    justify-content: center;
`;
export default function NotFound({route}) {
    const {url} = route?.params || {};
    return (
        <Container>
            <Card>
                <Icon name="home" />
                <Text>{url}</Text>
                <Text>Not Found</Text>
            </Card>
        </Container>
    )
}
